import React from 'react'
import "./chatloader.css"

const ChatLoader = () => {
    return (
        <div className="chat-bubble">
            <div className="typing">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
        </div>
    )
}

export default ChatLoader